/**
 * 最終処分場
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/final_disposal_sites`

const search_final_disposal_site = {
  namespaced: true,
  actions: {
    /**
     * 最終処分場取得
     * @return {Promise<unknown>}
     */
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
  },
}

export default search_final_disposal_site
